<template>
  <div class="card p-4">
    <div class="row">
      <div class="col-lg-2 text-right">
        <img src="/app/assets/logo.png" width="100px" alt="" />
      </div>
      <div class="col-lg-10 text-left">
        <br />
        <br />
        <h2>
          BIENVENID@
          {{
            this.$store.state.usuario.tipo == 2
              ? "ADMINISTRADOR"
              : this.$store.state.usuario.tipo == 3
              ? "RESPONSABLE FFVV"
              : $store.state.usuario.tipo == 4
              ? "RESPONSABLE PDV"
              : $store.state.usuario.tipo == 5
              ? "RESPONSABLE AACC"
              : $store.state.usuario.tipo == 6
              ? "RESPONSABLE VVMM"
              : "RESPONSABLE MMARCA"
          }}
          {{ filtrarDepartamento(this.$store.state.usuario.id_depa) }} <br />
          {{
            this.$store.state.usuario.nombres +
            " " +
            this.$store.state.usuario.appa +
            " " +
            this.$store.state.usuario.apma
          }}
        </h2>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12 text-center">
        <img class="img-fluid" src="/app/assets/claro.jpg" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Bienvenido",
  methods: {
   filtrarDepartamento(idDepartamento) {
  // Verificar si se proporcionó un idDepartamento
  if (idDepartamento === undefined || idDepartamento === null) {
    return '';
  }

  // Buscar el departamento
  const departamentoEncontrado = this.$store.state.dataDepartamentos.find(
    elemento => elemento.id == idDepartamento
  );

  // Verificar si se encontró el departamento y si tiene la propiedad 'departamento'
  if (departamentoEncontrado && departamentoEncontrado.departamento) {
    return '(' + departamentoEncontrado.departamento + ')';
  }

  // Retornar string vacío si no cumple las condiciones
  return '';
}
  },
};
</script>
